module.exports = __webpack_public_path__ + "img/0Q3A7263_FoamcoreMatted.9939cc67.jpg";